<script>
export default {
  name: 'TextWithHighlight',
  functional: true,
  props: {
    /**
     * Text to be highlighted
     *
     * @type {string}
     */
    highlightedText: {
      type: String,
      required: true
    },
    /**
     * Complete text of which highlighted text is a part
     *
     * @type {string}
     */
    fullText: {
      type: String,
      required: true
    },
    /**
     * Color of the highlighted text
     *
     * @type {string}
     */
    highlightColor: {
      type: String,
      default: '#dd0031'
    }
  },
  render(createElement, { props }) {
    const highlightedTextRegexp = new RegExp(props.highlightedText.trim(), 'gi')

    // Render the full text without highlighting, if there is no match for highlightedText
    if (!props.fullText.match(highlightedTextRegexp)) {
      return createElement('p', props.fullText)
    }

    const highlightedText = props.fullText.match(highlightedTextRegexp)[0]
    const highlightedMarkup = `<span style="color: ${props.highlightColor}; font-weight: 500;">${highlightedText}</span>`
    const fullMarkup = props.fullText.replace(
      highlightedTextRegexp,
      highlightedMarkup
    )

    return createElement('p', {
      domProps: {
        innerHTML: fullMarkup
      }
    })
  }
}
</script>
